// A new tab opened inside the tap, pointed at the file once it has arrived.
//
// iOS Safari, like every popup blocker, refuses window.open after an await:
// by the time the file has been fetched the tap that asked for it is over, so
// the sent resume, the cover letter and the confirmation screenshot did
// nothing on a phone. The tab opens while the tap is still running, says
// "Opening…", and is pointed at the file when it lands. If even that was
// refused, the file opens in this tab instead, which Back returns from
// (2026-09-30).
export function openPendingTab() {
  let tab = null;
  try { tab = window.open('', '_blank') || null; } catch { tab = null; }
  if (tab) {
    // The page it will show is our own file, which has no business with the
    // page that opened it.
    try { tab.opener = null; } catch { /* nothing to drop */ }
    try {
      tab.document.title = 'Opening…';
      if (tab.document.body) tab.document.body.textContent = 'Opening…';
    } catch { /* not ours to write */ }
  }
  return {
    show(url) {
      if (tab && !tab.closed) { tab.location.href = url; return; }
      window.location.assign(url);
    },
    close() {
      if (tab && !tab.closed) tab.close();
    },
  };
}
